import React, { memo } from 'react';
import type { TrialModuleKey } from '../../types';

export const TRIAL_MODULE_ICON_PATHS: Record<TrialModuleKey, string> = {
  news: 'M3 11v2a1 1 0 001 1h2l5 4V6L6 10H4a1 1 0 00-1 1zM15 9a3 3 0 010 6M18 6a7 7 0 010 12',
  chat: 'M4 5h16v11H9l-5 4V5z',
  directory: 'M9 11a4 4 0 100-8 4 4 0 000 8zM2 21c1-4 4-6 7-6s6 2 7 6M17 11a3 3 0 100-6M22 21c-.5-3-2.5-5-5-5.5',
  events: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  kb: 'M4 5a2 2 0 012-2h13v16H6a2 2 0 00-2 2V5zM4 19a2 2 0 012-2h13',
  ai: 'M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2z',
  forms: 'M9 3h6v3H9zM7 4.5H5V21h14V4.5h-2M8 11h8M8 15h5',
  tasks: 'M9 6h11M9 12h11M9 18h11M4 6l1 1 2-2M4 12l1 1 2-2M4 18l1 1 2-2',
  onboarding: 'M5 21V4M5 4h11l-2 4 2 4H5',
  elearning: 'M2 9l10-5 10 5-10 5L2 9zM6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5',
  performance: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  analytics: 'M4 20V4M4 20h16M8 16v-4M12 16V8M16 16v-6',
  surveys: 'M12 3a9 9 0 100 18 9 9 0 000-18zM9.5 9.5a2.5 2.5 0 014.6 1.3c0 1.7-2.1 1.9-2.1 3.4M12 17.5v.01',
  recognition: 'M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z',
};

export const TRIAL_CHECK_PATH = 'M5 12l5 5 9-10';
export const TRIAL_DOWNLOAD_PATH = 'M12 4v11M7 10l5 5 5-5M5 20h14';
export const TRIAL_OPEN_PATH = 'M7 17L17 7M9 7h8v8';

type Props = {
  d: string;
  size: number;
  className?: string;
  stroke?: string;
  strokeWidth?: number | string;
};

export const TrialStrokeIcon = memo(({
  d, size, className, stroke = 'currentColor', strokeWidth = 2,
}: Props) => (
  <svg
    className={className}
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d={d} />
  </svg>
));
